import { useMemo } from 'react';
import { managedLocations } from './managedLocations';
import { useAuth } from './useAuth';

/**
 * The signed-in user's locations (see managedLocations), as an array whose
 * identity only changes when the locations do, so it is safe in effect deps.
 */
export function useManagedLocations(): string[] {
  const { userMetadata } = useAuth();
  const locations = managedLocations(userMetadata);
  const key = locations.join('\n');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => locations, [key]);
}
